export default __webpack_public_path__ + "static/media/I28.e9227980.jpg";